import { render, staticRenderFns } from "./PatchSiblings.vue?vue&type=template&id=8b400cb2&"
import script from "./PatchSiblings.vue?vue&type=script&lang=js&"
export * from "./PatchSiblings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports